import React from "react";
import I18n from "../../../i18n/";
import { CounselingGeneric } from "./index";
import ReportAction from "../../../actions/ReportAction";
import { TargetValueType } from "../CompareValuePanel";
import { CounselingSupportGraph } from "../../../constants/supportGraph";

export default (props)=>(
	<CounselingGeneric 
		typeKey={CounselingSupportGraph.Tag}
		subHeader={I18n.t("topic")}
		fetchMain={ReportAction.fetchCounTopic}
		getAutoSelectItem={(totalRes)=>{
			let max = 0;
			let index = 0;
			const keys = Object.keys(totalRes);
			keys.forEach((k,i)=>{
				if(totalRes[k].count > max){
					max = totalRes[k].count;
					index = i;
				}
			});
			return {
				title:keys[index], 
				id:totalRes[keys[index]].id
			};
		}}
		mainSelectToFilterValue={(typeKey, value)=>{
			return value;
		}}
	/>
);


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/Counseling/CounselingTopic.js